import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import {
  AllMetrics,
  AllMetricsTwoColumnsLayout,
} from 'views/Results/Insights/CategoryMetrics/AllMetrics';

import { CategoryMetrics } from './CategoryMetrics/CategoryMetrics';
import { SubMetricDetail } from './SubMetricDetail/SubMetricDetail';
import useFeature from 'services/features/useFeature';

export const InsightsRoutes = () => {
  const { kitId } = useParams<{
    kitId: string;
    section: string;
    category: string;
  }>();

  const { isFeatureEnabled: showInsightsV2 } = useFeature('insights_v2');

  return (
    <Routes>
      <Route
        path={`:category/:subMetricId`}
        element={<SubMetricDetail key='insights-submetric-detail' />}
      />
      <Route
        path={`/all-insights`}
        element={
          showInsightsV2 ? (
            <AllMetricsTwoColumnsLayout key='insights-all-metrics-v2' />
          ) : (
            <AllMetrics key='insights-all-metrics-v1' />
          )
        }
      />
      <Route
        path={`:category`}
        element={<CategoryMetrics key='insights-category-metrics' />}
      />
      <Route
        path={``}
        key='insights'
        element={<Navigate to={`/results/${kitId}`} replace />}
      />
    </Routes>
  );
};
